import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { bizAPI, saveTokens } from '../services/api';

const GREEN = '#62CF5A';
const BEBAS = { fontFamily: "'Bebas Neue', sans-serif" };
const inputCls = 'w-full bg-[#141412] border border-[#2A2A26] rounded-[10px] px-4 h-12 text-white placeholder-[#555] focus:outline-none focus:border-[#62CF5A] transition-colors text-sm';

export default function JoinPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ invite_code: '', business_name: '', email: '', password: '' });
  const [busy, setBusy] = useState(false);
  const [disclosure, setDisclosure] = useState(null);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await bizAPI.redeem(form);
      saveTokens(data.access_token, data.refresh_token);
      setDisclosure(data.fee_disclosure);
      toast.success(`Welcome, ${data.business_name}!`);
      setTimeout(() => { window.location.href = '/dashboard'; }, 1800);
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg || err?.response?.data?.detail || 'Could not redeem invite');
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-5" style={{ fontFamily: "'Barlow', sans-serif" }} data-testid="join-page">
      <div className="w-full max-w-md">
        <Link to="/"><img src="/brand/divispend-logo.png" alt="Divispend" className="h-14 w-auto mx-auto mb-8" /></Link>
        {disclosure ? (
          <div className="text-center" data-testid="join-success">
            <h1 className="text-3xl mb-3" style={BEBAS}>You&rsquo;re in.</h1>
            <p className="text-sm text-[#999]">Taking you to your dashboard…</p>
          </div>
        ) : (
          <>
            <h1 className="text-4xl text-center mb-1" style={BEBAS}>Redeem your invite</h1>
            <p className="text-sm text-[#999] text-center mb-8">Enter the invite code from your waitlist email to activate your business account.</p>
            <form onSubmit={submit} className="space-y-3">
              <input value={form.invite_code} onChange={set('invite_code')} placeholder="Invite code (e.g. F6CPFLZS)" required className={`${inputCls} uppercase tracking-widest text-center`} data-testid="join-code" />
              <input value={form.business_name} onChange={set('business_name')} placeholder="Business name" required className={inputCls} data-testid="join-business-name" />
              <input type="email" value={form.email} onChange={set('email')} placeholder="Email" required className={inputCls} data-testid="join-email" />
              <input type="password" value={form.password} onChange={set('password')} placeholder="Password (8+ characters)" required minLength={8} className={inputCls} data-testid="join-password" />
              <button type="submit" disabled={busy} className="w-full h-12 rounded-[10px] font-bold text-black text-sm disabled:opacity-60" style={{ background: GREEN }} data-testid="join-submit">
                {busy ? 'Activating…' : 'Activate account'}
              </button>
            </form>
            <p className="text-[11px] text-[#666] mt-4 text-center leading-relaxed">0% platform fees during beta. A 1.5% platform fee applies after the beta period — you&rsquo;ll be notified before any fee takes effect.</p>
            <p className="text-xs text-[#777] mt-6 text-center">Already activated? <Link to="/login" className="hover:text-white" style={{ color: GREEN }} data-testid="join-login-link">Sign in</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
